export default __webpack_public_path__ + "ibm-plex-mono-regular.c708fd4f02694c48059ff599eaab6a33.woff2";